/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios, { AxiosResponse } from "axios";
import { AppDispatch } from "..";
import { Tenant } from "../../models";

import jwt_decode from "jwt-decode";
import { ConfigurationVariables } from "../../config";
import FilterJson from "../../models/FilterJson";
import { tenantActions } from "./tenant-slice";

import { StatusCode } from "../../models/apiModels/Tenant";

interface UserToken {
  sub: number;
  ext: {
    customer: string;
    tenant_id: string;
  };
}

const {
  TenantMgmt_Endpoints,
  Api,
  Version,
  RouteSettings,
  TenantController,
  RouteMetaData,
  GeoMappingAddress,
  OrganisationController,
  RouteIdentityProviders,
  RouteCountryCode,
  RouteApplications,
} = ConfigurationVariables;

/////////////////////////////Get Geo Mapping
export const getGeoMapping = createAsyncThunk(
  "tenant/getGeoMapping",
  async (arg, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      };
      const response: AxiosResponse<any> = await axios.get(
        `${TenantMgmt_Endpoints}/${Api}/${Version}/${RouteMetaData}/${GeoMappingAddress}`,
        config
      );

      if (response.status !== 200) {
        return rejectWithValue(response);
      }

      return response;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);

// To fetch organisation logo for tenant
export const getOrganisationLogo = createAsyncThunk(
  "tenant/getOrgLogo",
  async (
    arg: { tenantId: string; organizationId: string },
    { rejectWithValue }
  ) => {
    try {
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      };
      const response: AxiosResponse<string> = await axios.get(
        `${TenantMgmt_Endpoints}/${Api}/${Version}/${TenantController}/${arg.tenantId}/${OrganisationController}/${arg.organizationId}/logo`,
        config
      );

      if (response.status !== 200 && response.status !== 204) {
        return rejectWithValue(response);
      }
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);

export const getIdentityProviderbyTenantId = createAsyncThunk(
  "tenant/getIdentityProviderbyTenantId",
  async (tenantId: string, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      };
      const response: AxiosResponse<any> = await axios.get(
        `${TenantMgmt_Endpoints}/${Api}/${Version}/${TenantController}/${tenantId}/${RouteIdentityProviders}`,
        config
      );

      if (response.status !== 200) {
        return rejectWithValue(response);
      }
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);

export const getCountryCodes = createAsyncThunk(
  "tenant/getCountryCodes",
  async (arg, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      };

      const response: AxiosResponse<any> = await axios.get(
        `${TenantMgmt_Endpoints}/${Api}/${Version}/${RouteMetaData}/${RouteCountryCode}`,
        config
      );

      if (response.status !== 200) {
        return rejectWithValue(response);
      }
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);

//////////////////////////// Get avilable Data centres
export const getAvailableDataCenters = createAsyncThunk(
  "tenant/getAvailableDataCenters",
  async (arg, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      };

      const response: AxiosResponse<any> = await axios.get(
        `${TenantMgmt_Endpoints}/${Api}/${Version}/${RouteMetaData}/datacenters`,
        config
      );

      if (response.status !== 200) {
        return rejectWithValue(response);
      }

      return response;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);
////// Get available timezones

export const getAvailableTimeZones = createAsyncThunk(
  "tenant/getAvailableTimeZones",
  async (arg, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      };

      const response: AxiosResponse<any> = await axios.get(
        `${TenantMgmt_Endpoints}/${Api}/${Version}/${RouteMetaData}/timezones`,
        config
      );

      if (response.status !== 200) {
        return rejectWithValue(response);
      }

      return response;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);

/// Get available currencies
export const getAvailableCurrencies = createAsyncThunk(
  "tenant/getAvailableCurrencies",
  async (arg, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      };

      const response: AxiosResponse<any> = await axios.get(
        `${TenantMgmt_Endpoints}/${Api}/${Version}/${RouteMetaData}/currencies`,
        config
      );

      if (response.status !== 200) {
        return rejectWithValue(response);
      }

      return response;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);

///////////////////get Tenant logo for Tenant edit///////////
export const getTenantLogo = createAsyncThunk(
  "tenant/getTenantLogo",
  async (tenantID: string, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      };
      const response: AxiosResponse<string> = await axios.get(
        `${TenantMgmt_Endpoints}/${Api}/${Version}/${TenantController}/${tenantID}/logo`,
        config
      );
      if (response.status !== 200 && response.status !== 204) {
        return rejectWithValue(response);
      }
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);

/////////////////// end get Tenant logo for Tenant edit///////////

/// Get available products
export const getAvailableProducts = createAsyncThunk(
  "tenant/getAvailableProducts",
  async (arg, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      };

      const response: AxiosResponse<any> = await axios.get(
        `${TenantMgmt_Endpoints}/${Api}/${Version}/${RouteMetaData}/products`,
        config
      );

      if (response.status !== 200) {
        return rejectWithValue(response);
      }

      return response;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);

// searchTenants
export const searchTenants = (searchText: string) => {
  return (dispatch: AppDispatch) => {
    dispatch(tenantActions.filerTenantsBasedOnSearchText(searchText));
  };
};
/// End code from cart-actions

/// Code from app-actions

export const sendFilteredListApp = (filteredApplications: Array<string>) => {
  return (dispatch: AppDispatch) => {
    try {
      dispatch(tenantActions.showFilteredList(filteredApplications));
    } catch (error) {}
  };
};

export const selectedApplications = (selectedApplications: Array<string>) => {
  //filteredApplications : any inside ()
  return (dispatch: AppDispatch) => {
    try {
      dispatch(
        tenantActions.filterusingselectedApplication(selectedApplications)
      );
    } catch (error) {}
  };
};

export const selectedRegions = (selectedRegion: Array<string>) => {
  //filteredRegion : any inside ()
  return (dispatch: AppDispatch) => {
    try {
      dispatch(tenantActions.filterusingselectedLocation(selectedRegion));
    } catch (error) {}
  };
};

export const sendFilteredData = (filteredData: Array<Tenant>) => {
  return (dispatch: AppDispatch) => {
    try {
      dispatch(tenantActions.createfilteredList(filteredData));
    } catch (error) {}
  };
};
/// End code from app-actions

export const getTenantDetailsByTenantId = createAsyncThunk(
  "tenant/getTenantDetailsByTenantId",
  async (
    arg: {
      tenantId: any;
    },
    { rejectWithValue }
  ) => {
    try {
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      };
      const response: any = await axios.get(
        `${TenantMgmt_Endpoints}/${Api}/${Version}/${TenantController}/${arg.tenantId}`,
        config
      );
      if (response.status != 200) {
        return rejectWithValue(response.data);
      }

      const status = response.data.status;

      response.data = {
        ...response.data,
        statusCode: response.status,
        status: covertToTenantStatus(response.data.status),
      };

      return response.data;
    } catch (error: any) {
      const initialData = {
        tenantId: "",
        tenantName: "",
        timezone: "",
        datacenter: "",
        currency: "",
        lastUpdatedTimeStamp: "",
        region: 0,
        country: 0,
        zipcode: "",
        createdon: "",
        state: "",
        version: 0,
        statusCode: 0,
      };

      var responseError = {
        data: {},
      };
      if (error?.response?.status == 404) {
        responseError.data = {
          ...initialData,
          statusCode: error?.response?.status,
          status: covertToTenantStatus(StatusCode.noTenant),
        };
        return rejectWithValue(responseError.data);
      } else {
        responseError.data = {
          ...initialData,
          statusCode: error?.response?.status,
          status: covertToTenantStatus(StatusCode.Invalid),
          error: error,
        };
        return rejectWithValue(responseError.data);
      }
    }
  }
);
export const fetchFilterCounts = createAsyncThunk(
  "tenant/fetchFilterCounts",
  async (arg, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      };

      const response: AxiosResponse<any> = await axios.get(
        `${TenantMgmt_Endpoints}/${Api}/${Version}/${RouteMetaData}/filters`,
        config
      );

      if (response.status !== 200) {
        //
        return rejectWithValue(response);
      }

      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);
export const getCertificate = createAsyncThunk(
  "tenant/getCertificate",
  async (
    data: {
      products: string;
      certificateGenerationRequest: string;
      tenantId: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      };

      const response = await axios.post(
        `${TenantMgmt_Endpoints}/${Api}/${Version}/${TenantController}/${
          data.tenantId
        }/${RouteApplications}/${data.products.toLowerCase()}/certificates`,
        { certificateGenerationRequest: data.certificateGenerationRequest },
        config
      );
      if (response.status !== 200 && response.status !== 204) {
        return rejectWithValue(response.data);
      }

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const editTenantDetails = createAsyncThunk(
  "tenant/editTenantDetails",
  async (postData: any, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      };

      const response = await axios.put(
        `${TenantMgmt_Endpoints}/${Api}/${Version}/${TenantController}/${postData.id}`,
        postData,
        config
      );
      // CID 3289794
      if (response.status !== 200 && response.status !== 204) {
        return rejectWithValue(response.data);
      }

      response.data = {
        ...response.data,
        statusCode: response.status,
        status: covertToTenantStatus(response.data.status as string),
      };

      return response.data;
    } catch (error: any) {
      const initialData = {
        tenantId: "",
        tenantName: "",
        timezone: "",
        datacenter: "",
        currency: "",
        lastUpdatedTimeStamp: "",
        region: 0,
        country: 0,
        zipcode: "",
        createdon: "",
        state: "",
        version: 0,
        statusCode: 0,
      };

      var responseError = {
        data: {},
      };

      responseError.data = {
        ...initialData,
        statusCode: error?.response?.status,
        status: covertToTenantStatus(StatusCode.TenantUpdated),
        error: error,
      };

      return rejectWithValue(responseError.data);
    }
  }
);

/// Delete tenant
export const deleteTenant = createAsyncThunk(
  "tenant/deleteTenant",
  async (id: string, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          id: id,
          Authorization: "Bearer " + getAccessToken(),
        },
      };

      const response = await axios.delete(
        `${TenantMgmt_Endpoints}/${Api}/${Version}/${TenantController}/${id}`,
        config
      );

      if (response.status !== 200) {
        return rejectWithValue(response);
      }

      return id;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);

export const createTenantDetails = createAsyncThunk(
  "tenant/createTenantDetails",
  async (postData: any, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      };
      const response: AxiosResponse<Tenant> = await axios.post(
        `${TenantMgmt_Endpoints}/${Api}/${Version}/${TenantController}`,
        postData,
        config
      );
      // CID 3289794
      if (response.status != 200) {
        return rejectWithValue(response.data);
      }

      if (!response.data) {
        return rejectWithValue("No data in response");
      }

      response.data = {
        ...response.data,
        statusCode: response.status,
        status: covertToTenantStatus(response.data.status as string),
      };

      return response.data;
    } catch (error: any) {
      const initialData = {
        tenantId: "",
        tenantName: "",
        timezone: "",
        datacenter: "",
        currency: "",
        lastUpdatedTimeStamp: "",
        region: 0,
        country: 0,
        zipcode: "",
        createdon: "",
        state: "",
        version: 0,
        statusCode: 0,
      };

      var responseError = {
        data: {},
      };

      responseError.data = {
        ...initialData,
        statusCode: error?.response?.status,
        status: covertToTenantStatus(StatusCode.noTenant),
        error: error,
      };

      return rejectWithValue(responseError.data);
    }
  }
);
//// Upload new code begin
export const uploadTenantLogoDetails = createAsyncThunk(
  "tenant/uploadTenantLogoDetails",

  async (parameters: any, { rejectWithValue }) => {
    try {
      let formData = new FormData();
      formData.append("logo", parameters.fileName);
      formData.append("id", parameters.tenantId);

      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      };

      const response = await axios.put(
        `${TenantMgmt_Endpoints}/${Api}/${Version}/${TenantController}/${parameters.tenantId}/logo`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + getAccessToken(),
            id: parameters.tenantId,
          },
        }
      );

      if (response.status !== 200) {
        return rejectWithValue(response);
      }

      return response;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);

/// Upload new code end
export const getAccessToken = () => {
  if (
    (sessionStorage.getItem("oidc.default") as any) === undefined ||
    (sessionStorage.getItem("oidc.default") as any) === null ||
    (sessionStorage.getItem("oidc.default") as any) === ""
  ) {
    return "";
  }
  const accessToken: string = JSON.parse(
    sessionStorage.getItem("oidc.default") as any
  )["tokens"]["accessToken"];
  if (accessToken === undefined || accessToken === null || accessToken === "") {
    throw new Error("Access token is not in valid format");
  }
  return accessToken;
};

// function createRequiredTenant(tenant: Tenant, postData: any) {
//   return {
//     id: postData.id,
//     tenantName: tenant.tenantName,
//     headquarterAddress: tenant.headquarterAddress,
//     timezone: tenant.timezone,
//     datacenter: tenant.datacenter,
//     currency: tenant.currency,
//     applications: tenant?.products?.map((product) => product?.productId),
//     region: tenant.region,
//     country: tenant.country,
//     zipcode: tenant.zipcode,
//     lastUpdatedTimeStamp: tenant.lastUpdatedTimeStamp,
//     createdon: tenant.createdon,
//     version: tenant.version,
//   };
// }

/// Get List of available regions
export const getAvailableRegions = createAsyncThunk(
  "tenant/getAvailableRegions",
  async (arg, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      };

      const response: AxiosResponse<any> = await axios.get(
        `${TenantMgmt_Endpoints}/${Api}/${Version}/${RouteMetaData}/regions`,
        config
      );

      if (response.status !== 200) {
        return rejectWithValue(response);
      }

      return response;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);

/// Get list of avaialble Countries
export const getAvailableCountries = createAsyncThunk(
  "tenant/getAvailableCountries",
  async (arg, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      };

      const response: AxiosResponse<any> = await axios.get(
        `${TenantMgmt_Endpoints}/${Api}/${Version}/${RouteMetaData}/countries`,
        config
      );

      if (response.status !== 200) {
        return rejectWithValue(response);
      }

      return response;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);

/// Function to fetch Customer id from user token

const isUserToken = (user: any): user is UserToken => {
  return typeof user === "object" && "sub" in user && "ext" in user;
};

/// Get  settings for a tenant
export const getSettingsForTenant = createAsyncThunk(
  "tenant/getSettingsForTenant",

  async (tenantId: string, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      };

      const response: AxiosResponse<any> = await axios.get(
        `${TenantMgmt_Endpoints}/${Api}/${Version}/${RouteSettings}/${TenantController}/${tenantId}`,
        config
      );
      if (response.status !== 200) {
        return rejectWithValue(response);
      }
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);
// getMetaSettingsForProduct
export const getMetaSettingsForProduct = createAsyncThunk(
  "tenant/getMetaSettingsForProduct",

  async (productId: string, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      };
      // Get tenant Id from token to pass in URL as params

      let response: AxiosResponse<any> = await axios.get(
        `${TenantMgmt_Endpoints}/${Api}/${Version}/${RouteMetaData}/${RouteApplications}/${productId}`,
        config
      );

      if (response.status !== 200) {
        return rejectWithValue(response);
      }
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);

// update settings of tenant product

export const updateSettingsForTheProduct = createAsyncThunk(
  "tenant/updateSettingsForTheProduct",

  async (settingsAndTenant: any, { rejectWithValue }) => {
    try {
      const postData = settingsAndTenant.setting;
      const tenantId = settingsAndTenant.tenantId;

      const productId = postData.productId;
      const onlysettingsBody = postData.changedSettings.map((setting: any) => {
        return {
          key: setting.key,
          value: setting.value,
          type: setting.type,
        };
      });
      const requestBody = {
        settings: onlysettingsBody,
        version: postData.version,
      };
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      };

      const response = await axios.put(
        `${TenantMgmt_Endpoints}/${Api}/${Version}/${RouteSettings}/${TenantController}/${tenantId}/${RouteApplications}/${productId}`,
        requestBody,
        config
      );

      if (response.status !== 200) {
        return rejectWithValue(response);
      }
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);

export const getSettingsByTenantId = createAsyncThunk(
  "tenant/getSettingsByTenantId",
  async (tenantid: string, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      };

      const response: AxiosResponse<any> = await axios.get(
        `${TenantMgmt_Endpoints}/${Api}/${Version}/${RouteSettings}/${TenantController}/${tenantid}`,
        config
      );
      if (response.status !== 200) {
        return rejectWithValue(response);
      }

      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);

export const setStatusforTenant = createAsyncThunk(
  "tenant/setStatusforTenant",
  async (tenantid: string, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      };
      const response: AxiosResponse<any> = await axios.put(
        `${TenantMgmt_Endpoints}/${Api}/${Version}/${TenantController}/${tenantid}/status`,
        {},
        config
      );
      if (response.status !== 200) {
        return rejectWithValue(response);
      }

      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);

function covertToTenantStatus(status: string) {
  switch (status) {
    case "InIt":
      return StatusCode.InIt;
    case "SetupCompleted":
      return StatusCode.SetupCompleted;
    case "InProgress":
      return StatusCode.InProgress;
    case "UpdateInprogress":
      return StatusCode.TenantUpdated;
    case "noTenant":
      return StatusCode.noTenant;
    default:
      return StatusCode.Invalid;
  }
}
